import { render, staticRenderFns } from "./shengyiafter.vue?vue&type=template&id=3cbfe730&scoped=true&"
import script from "./shengyiafter.vue?vue&type=script&lang=js&"
export * from "./shengyiafter.vue?vue&type=script&lang=js&"
import style0 from "./shengyiafter.vue?vue&type=style&index=0&id=3cbfe730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbfe730",
  null
  
)

export default component.exports